/**
 * Design Tokens for Weidner Apartment Homes Theme
 * 
 * Extends the base aster theme tokens with Weidner Apartment Homes branding.
 */

import type { DesignTokens } from '@vibesites/tokens';
import { tokens as baseTokens } from '@vibesites/theme-aster/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Weidner Apartment Homes brand colors and typography.
 * Customize these values to match your brand guidelines.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    ...baseTokens.color,
    // Weidner Apartment Homes brand colors - customize these
    // primary: '#your-primary-color',
    // secondary: '#your-secondary-color',
    // accent: '#your-accent-color',
  },
  font: {
    ...defaultTokens.font,
    ...baseTokens.font,
    // Match Duda brand typography (e.g. 35degreesapartments.com):
    // Montserrat headings, Poppins body — replaces Space Mono.
    heading: "'Montserrat', sans-serif",
    body: "'Poppins', sans-serif",
    accent: "'Montserrat', sans-serif",
    mono: "'Poppins', sans-serif",
  },
};

export default tokens;
